export const API_BASE_URL = 'https://dev.api.beaive.com';

